import React from 'react';
import BODCard from './BODCard';


const Section1 = ()=>{

    const boardOfDirectors =  {
                                    'data': 
                                    [
                                        {
                                            "name":"Ayesha Raza Farooq",
                                            "qualification":"MBA 1995",
                                            "img":"./images/boardOfDirectors/1.jpg"
                                        },
                                        {
                                            "name":"Muhammad Saad Munawar",
                                            "qualification":"MBA 2006 (President)",
                                            "img":"./images/boardOfDirectors/2.jpg"
                                        },
                                        {
                                            "name":"Hassan Khan Sherwani",
                                            "qualification":"EMBA 2016",
                                            "img":"./images/boardOfDirectors/3.jpg"
                                        },
                                        {
                                            "name":"Naveed Asghar",
                                            "qualification":"MBA 1993",
                                            "img":"./images/boardOfDirectors/4.jpg"
                                        },
                                        {
                                            "name":"Rehan Elahi",
                                            "qualification":"MBA 2012",
                                            "img":"./images/boardOfDirectors/5.jpg"
                                        },
                                        {
                                            "name":"Roohina Jamshed",
                                            "qualification":"MBA 1997",
                                            "img":"./images/boardOfDirectors/6.jpg"
                                        },
                                        {
                                            "name":"Saima Rana",
                                            "qualification":"MBA 1996",
                                            "img":"./images/boardOfDirectors/7.jpg"
                                        },
                                        {
                                            "name":"Shahzad Saleem",
                                            "qualification":"MBA 1989",
                                            "img":"./images/boardOfDirectors/8.jpg"
                                        },
                                        {
                                            "name":"Sajjad Mustafa Sayyed",
                                            "qualification":"EMBA 2005",
                                            "img":"./images/boardOfDirectors/9.jpg"
                                        },
                                        {
                                            "name":"Sunil Sarfraz Munj",
                                            "qualification":"MBA 2005",
                                            "img":"./images/boardOfDirectors/10.png"
                                        }
                                    ]
                            };


    return(

        <div className="boardOfDirectors">
            <div className="row directorsWrapper">
               
              <BODCard boardOfDirectors={boardOfDirectors} />
                
            </div>
        </div>
    );

}

export default React.memo(Section1);